// Category Product List Page

export default function karteCategory(kCategory: any) {
  try {
    const category = {
      category_num: kCategory.id,
      category_id: kCategory.id + "",
      category_name: kCategory.name,
      category_url:
        window.location.origin +
        "/product-list/?product-category=" +
        kCategory.id
      // brand: "brandA",
      // gender_id: "01",
      // color_id: "06",
      // keyword: "スカート"
    };

    (window as any).tracker.track("view_category", category);
  } catch (e) {
	if (e instanceof Error) {
	    if ("tracker" in window) {
	      (window as any).tracker.track("_error", {
	        message: e.message
	      });
	    }
	}
  }
}
